import { Link } from "react-router-dom";
import type { Work } from "@/types/film";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  const meta = work.category === "movie" ? work.duration : `${work.episodes} 集`;

  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block cursor-pointer"
      title={`${work.title} - 详情介绍`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} - 白虎影视平台`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-accent-500 px-1.5 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {work.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-0 bottom-0 translate-y-2 p-3 text-xs font-medium text-background-50 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          {meta}
        </span>
      </div>
      <h3 className="mt-2 truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600 md:text-base">
        {work.title}
      </h3>
      <p className="mt-0.5 truncate text-xs text-foreground-500">
        {work.genres.slice(0, 2).join(" · ")} · {work.year}
      </p>
    </Link>
  );
}